// Checkbox — a thin wrapper over the native input that also drives the
// `indeterminate` property (which has no HTML attribute, only a DOM property),
// so a "select all" header can show the tristate when only some rows are ticked.
// Stops click propagation by default so ticking a row inside a clickable
// table row doesn't also fire the row's onClick.

import { cn } from '@/lib/utils';
import { useEffect, useRef, type InputHTMLAttributes } from 'react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    indeterminate?: boolean;
}

export default function Checkbox({
    indeterminate = false,
    className,
    onClick,
    ...rest
}: CheckboxProps) {
    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (ref.current) ref.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return (
        <input
            ref={ref}
            type="checkbox"
            onClick={(e) => {
                e.stopPropagation();
                onClick?.(e);
            }}
            className={cn('septima-checkbox', className)}
            {...rest}
        />
    );
}
